module.exports = __webpack_public_path__ + "img/e_1_4_r.b3307ca1.png";